<template>
  <div id="login">
    <b-card>
      <div v-if="authenticated">
        <b-alert variant="success" show>{{ $t('signIn.signedIn', { name: `${user.first_name} ${user.last_name}` }) }}</b-alert>
      </div>
      <div v-else>
        <form @submit.prevent="submitSignIn">
          <div class="row">
            <div class="col-12">
              <b-form-input type="email" v-model="email" :placeholder="$t('placeholders.email')"></b-form-input>
              <b-form-input type="password" v-model="password" :placeholder="$t('placeholders.password')"></b-form-input>
            </div>
          </div>

          <b-row>
            <b-col>
              <response :items="errors" class="mb-3"></response>

              <b-button type="submit" class="sign-in" variant="primary">{{ $t('buttons.signIn') }}</b-button>
            </b-col>
          </b-row>
        </form>
      </div>
    </b-card>
    <b-row v-if="!authenticated" class="social-buttons">
      <b-col>
        <b-btn class="btn-social" variant="secondary" @click.prevent="authenticate('google')"><img height="24" src="@/assets/images/logo-google.svg" /> {{ $t('buttons.signInGoogle') }}</b-btn>
      </b-col>
      <b-col>
        <b-btn class="btn-social" variant="secondary" @click.prevent="authenticate('facebook')"><img height="24" src="@/assets/images/logo-fb.svg" /> {{ $t('buttons.signInFacebook') }}</b-btn>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'SignIn',
    data: function () {
      return {
        email: '',
        password: '',
        alertMsg: '',
        alertType: '',
        showAlert: false,
        errors: [],
        success: null
      }
    },
    computed: {
      ...mapGetters({
        user: 'account/user',
        authenticated: 'account/authenticated'
      })
    },
    methods: {
      ...mapActions({
        signIn: 'auth/signIn',
        socialLogin: 'auth/socialSignIn',
        socialLoginToken: 'auth/socialLoginToken'
      }),
      submitSignIn: function () {
        let payload = {
          email: this.email,
          password: this.password
        }
        this.signIn({
          payload: payload,
          context: this
        })
      },
      authenticate: function (provider) {
        let payload = { token: 'empty', provider: provider }
        this.socialLogin({ payload: payload, context: this })
      }
    },
    mounted () {
//      var uiConfig = {
//        callbacks: {
//          signInSuccess: function(currentUser, credential, redirectUrl) {
//            // User successfully signed in.
//            // Return type determines whether we continue the redirect automatically
//            // or whether we leave that to developer to handle.
//            return true;
//          },
//          uiShown: function() {
//            // The widget is rendered.
//            // Hide the loader.
//            document.getElementById('loader').style.display = 'none'
//          }
//        },
//        signInSuccessUrl: '/account',
//        signInFlow: 'popup',
//        signInOptions: [
//          // List of OAuth providers supported.
//          firebaseApp.auth.GoogleAuthProvider.PROVIDER_ID,
//          firebaseApp.auth.FacebookAuthProvider.PROVIDER_ID
//        ],
//        tosUrl: '/terms'
//      }
//      let ui = firebaseUi.auth.AuthUI.getInstance()
//      if (!ui) {
//        ui = new firebaseUi.auth.AuthUI(firebaseApp.auth())
//      }
//      ui.start('#firebaseui-auth-container', uiConfig)
    },
    created () {
      // this.$store.dispatch('getUser')
    },
    destroyed() {
      // firebaseUi.auth.AuthUI.reset()
    }
  }
</script>

<style lang="scss" scoped>


  #login {
    margin: 0 auto;
    width: 100%;

    input {
      margin: 10px 0;
      width: 100%;
      padding: 15px;
    }
    button.sign-in {
      margin-top: 20px;
      width: 100%;
      cursor: pointer;
    }
    p {
      margin-top: 40px;
      font-size: 13px;
    }
    p a {
      text-decoration: underline;
      cursor: pointer;
    }

    .row.social-buttons {
      margin-left: -0.5rem;
      margin-right: -0.5rem;

      .col {
        padding: 0.5rem;

        .btn-social {
          width: 100%;
          margin-top: 0.5rem;
          text-align: left;
          color: black;
          border: none;
          border-bottom: 1px solid black;
          background-color: #FAFAFA !important;

          img {
            padding-right: 0.5rem;
          }
        }
      }
    }
  }
</style>
